module.exports = __webpack_public_path__ + "static/media/zoom_out.30dbd61e.svg";